import { CMDBaseInformation } from "./CMDBaseInformation"
import { CMDTeenPatti2020 } from "./CMDTeenPatti2020"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScInitTeenPatti2020 implements ICommand
{

	public Information : CMDBaseInformation;
	public OldResult : Array<CMDTeenPatti2020>;
	public CurrentState : number = 0;
	public CurrentResult : CMDTeenPatti2020;

	public constructor()
	{
		this.OldResult = new Array<CMDTeenPatti2020>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Information = new CMDBaseInformation();
		this.Information.fromBytes(ba);
		let OldResultSize:number = ba.readUint8();
		while (OldResultSize-- > 0)
		{
			let OldResultChild:CMDTeenPatti2020 = new CMDTeenPatti2020();
			OldResultChild.fromBytes(ba);
			this.OldResult.push(OldResultChild);
		}
		this.CurrentState = ba.readUint16();
		this.CurrentResult = new CMDTeenPatti2020();
		this.CurrentResult.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		let tempBuf0 = this.Information.toBytes().toBuffer();
		ba.appendBuf(tempBuf0)
		ba.writeUint8(this.OldResult.length);
		for (const OldResultChild of this.OldResult)
		{
			let tempBuf = OldResultChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}
		ba.writeUint16(this.CurrentState);
		let tempBuf4 = this.CurrentResult.toBytes().toBuffer();
		ba.appendBuf(tempBuf4)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScInitTeenPatti2020();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Information(CMDBaseInformation)='+this.Information+' ';
		str += 'OldResult_size(B)='+this.OldResult.length + ' ';
		str += 'OldResult(CMDTeenPatti2020)=[';
		for (let OldResultChild in this.OldResult)
		{
			if (<number><unknown>OldResultChild > 0) str += ', ';
			str += this.OldResult[OldResultChild].toString();
		}
		str += '] ';
		str += 'CurrentState(W)='+this.CurrentState+' ';
		str += 'CurrentResult(CMDTeenPatti2020)='+this.CurrentResult+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30512;
	}

	public getCmdName() : string
	{
		return 'ScInitTeenPatti2020';
	}

}
